/**
 * Storefront origins keyed by the SSO provider the session was created with.
 *
 * Nothing is sold or invoiced in this panel: money, invoices, cancelling and
 * support tickets all live on the shop the account signed in from. The two
 * brands are separate accounts, so sending somebody to the wrong hostname shows
 * them a login screen for an account they do not have.
 */
import type { SsoProvider } from '../api/types';

const STOREFRONT_ORIGIN: Record<SsoProvider, string> = {
  vgncloud: 'https://vgncloud.com',
  valuegamenode: 'https://valuegamenode.com',
};

export function storefrontOrigin(provider: string | undefined | null): string {
  if (provider === 'vgncloud' || provider === 'valuegamenode') {
    return STOREFRONT_ORIGIN[provider];
  }
  return STOREFRONT_ORIGIN.vgncloud;
}

/** Tickets live at /support on both shops. */
export function storefrontSupportUrl(provider: string | undefined | null): string {
  return `${storefrontOrigin(provider)}/support`;
}
